/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateDigitalWalletLinkRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CreateDigitalWalletLink.pb'
import {CreateDigitalWalletLinkResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CreateDigitalWalletLink.pb'


export const createDigitalWalletLink = (request:CreateDigitalWalletLinkRequest, options?: CashRequestOptions) => post<CreateDigitalWalletLinkRequest, CreateDigitalWalletLinkResponse>("/2.0/cash/create-digital-wallet-link", request, {...options, rejectOnError: true })